import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.maxStars, (star) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass([{ 'active': star <= $setup.stars }, "star me-0.5"]),
        key: star,
        onClick: ($event: any) => ($setup.rate(star))
      }, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['fas', 'star'],
          class: _normalizeClass(star <= $props.grade ? 'text-primary-500 dark:text-primaryDark-accent ' : 'hidden ' ),
          size: "sm"
        }, null, 8, ["class"]),
        _createVNode(_component_font_awesome_icon, {
          icon: ['far', 'star'],
          class: _normalizeClass(star <= $props.grade ? 'hidden ' : 'text-primary-500 dark:text-primaryDark-accent' ),
          size: "sm"
        }, null, 8, ["class"])
      ], 10, _hoisted_2))
    }), 128))
  ]))
}